import { z } from 'zod';
import { ArgoConnectionKindEnum } from '../db';
import { connectionTerminatorSchema } from './tcp-client.connection-config.zod';

export const tcpServerConnectionConfigSchema = z.object({
    kind: z.literal(ArgoConnectionKindEnum.TcpServer),
    details: z.object({
        port: z.number(),
        terminator: connectionTerminatorSchema,
    }),
});
export type TcpServerConnectionConfig = z.infer<typeof tcpServerConnectionConfigSchema>;
